import { FotoClient } from "@/api";

// const client = new FotoClient({ BASE: "http://localhost:37261" });

// https://nuxt.com/docs/getting-started/data-fetching#pass-cookies-from-server-side-api-calls-on-ssr-response

export const useApi = () => {
  const cookieHeaders = useRequestHeaders(["cookie"]);

  const config = useRuntimeConfig();

  const BASE = import.meta.server
    ? config.INTERNAL_SERVER_URL
    : config.public.BASE_URL;

  return new FotoClient({
    BASE,
    HEADERS: { ...cookieHeaders },
  });
};
